/**
 * This module contains bus service that manage communication between Geo App and Api
 * 
 * @module geo/bus
 * 
 * @private
 * @hidden
 */

/**
 * @preferred
 * 
 */
import { Store } from 'redux';

import { AppStore } from '../store/app';

import { BusServiceIframeSync } from './bus.iframe.sync';
import { BusService } from './bus.service';

/**
 * Factory of bus service.
 * @private
 */
export class GeoBusFactory {
  geoBus: BusService;
  geoBusSync: BusServiceIframeSync;

  constructor() {
    this.geoBus = new BusService();
    this.geoBusSync = new BusServiceIframeSync();
  }

  public init(config: any) {
    this.geoBus.init(config);
    this.geoBusSync.init(config);
  }

  public registerNewApp(uidApp: string, configApp: any) {
    this.geoBus.registerNewApp(uidApp, configApp);
    this.geoBusSync.registerNewApp(uidApp, configApp);
  }

  public setClientReceiver(c: string | HTMLIFrameElement, uidApp: string) {
    this.geoBus.setClientReceiver(c, uidApp);
    this.geoBusSync.setClientReceiver(c, uidApp);
  }

  public bindToStore(storeApp: Store<AppStore>, uidApp: string) {
    this.geoBus.bindToStore(storeApp, uidApp);
    this.geoBusSync.bindToStore(storeApp, uidApp);
  }

  public send<ResponseType>(type: string, message: any, uidApp: string): Promise<ResponseType> {
    return this.geoBus.send(type, message, uidApp);
  }
  public sendP<ResponseType>(type: string, message: any, uidApp: string): Promise<ResponseType> {
    return this.geoBus.send(type, message, uidApp);
  }
}

const geoBus = new GeoBusFactory();
export default geoBus;